import React, { useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import {
  CCard,
  CButton,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import CIcon from '@coreui/icons-react'
import { cilPencil, cilTrash } from '@coreui/icons'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { getCountriesAction } from '../../../Redux/Actions/userAction'
import { getSubscriptionAction } from '../../../Redux/Actions/pricingAction'
import { getCategoriesAction, getMetaData } from '../../../Redux/Actions/metaDataAction'
import { updateTemplate } from '../../../Redux/Actions/templateAction'
import { isEmpty, checkPermissions, raiseToast } from '../../utils/helper'
import SwimlaneModal from './SwimlaneModal'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { AppContext } from 'src/views/context/app'

const SwimlaneHomePage = ({ data, templateConfig, homePageConfig, getTemplate }) => {
  const dispatch = useDispatch()
  const language = localStorage.getItem('language')
  const [swimlane, setSwimlane] = useState([...data])
  const [openModal, setOpenModal] = useState(false)
  const [showChange, setShowChange] = useState(false)

  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [countries, setCountries] = useState([])
  const [customMetadataMaster, setCustomMetadataMaster] = useState([])
  const [customMetadata, setCustomMetadata] = useState({})
  const [subscriptions, setSubscriptions] = useState([])

  const [deleteModal, setDeleteModal] = useState(false)
  const [swimlaneIndex, setSwimlaneIndex] = useState('')

  const [selectedSwimlane, setSelectedSwimlane] = useState({})

  const { userSessionObj } = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.CREATE) &&
    defaultLangCheck
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.WEBSITE.UPDATE,
  )
  const deleteAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.DELETE) &&
    defaultLangCheck

  useEffect(() => {
    setSwimlane([...data])
  }, [data])

  useEffect(() => {
    getDynamicSwimlaneData()
  }, [])

  const getDynamicSwimlaneData = async () => {
    const countryRes = await dispatch(getCountriesAction())
    const categoryRes = await dispatch(getCategoriesAction())
    const metadataRes = await dispatch(getMetaData('custom'))
    const subscriptionRes = await dispatch(getSubscriptionAction())
    if (countryRes?.success) {
      setCountries(countryRes.data)
    }
    if (categoryRes?.success) {
      setCategories(categoryRes.data.filter((cat) => cat.type === 'category'))
      setSubCategories(categoryRes.data.filter((cat) => cat.type === 'sub_category'))
    }
    if (metadataRes?.success) {
      const meta = metadataRes.data.filter((item) => item.status && item.type !== 'text')
      setCustomMetadataMaster(meta)
      const metaObj = {}
      meta.forEach((item) => {
        metaObj[item.name] = { type: item.type, values: item.type === 'checkboxes' ? [] : '' }
      })
      setCustomMetadata(metaObj)
    }
    if (subscriptionRes?.data?.success) {
      setSubscriptions(subscriptionRes.data.data)
    }
  }

  const updateSwimlane = async (swimlaneData) => {
    let payload = {
      ...templateConfig,
      pages: {
        home_page: {
          ...homePageConfig,
          swimlanes: swimlaneData,
        },
      },
    }

    let templateRes = await dispatch(updateTemplate(payload))

    if (templateRes?.success) {
      getTemplate()
      return true
    }
    return false
  }

  const swimlaneCallback = async (swimalneObj) => {
    if (isEmpty(selectedSwimlane) && updateSwimlane([...data, swimalneObj])) {
      setOpenModal(false)
    }
    if (!isEmpty(selectedSwimlane)) {
      let tempArr = data
      tempArr[swimlaneIndex] = swimalneObj
      if (updateSwimlane([...tempArr])) {
        setOpenModal(false)
        setSelectedSwimlane({})
        setSwimlaneIndex('')
      }
    }
  }
  const saveReorder = async () => {
    if (updateSwimlane(swimlane)) {
      setShowChange(false)
    }
  }

  const onCancelReorder = () => {
    setSwimlane([...data])
    setShowChange(false)
  }

  const deleteSwimlane = (index) => {
    if (!deleteAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setDeleteModal(true)
    setSwimlaneIndex(index)
  }
  const handleConfirm = () => {
    swimlane.splice(swimlaneIndex, 1)
    if (updateSwimlane(swimlane)) {
      setDeleteModal(false)
    }
  }
  const handleCancel = () => {
    setSwimlaneIndex('')
    setDeleteModal(false)
  }

  const handleEdit = (info, index) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setSwimlaneIndex(index)
    setSelectedSwimlane(info)
    setOpenModal(true)
  }
  const handleAdd = () => {
    if (!createAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setSelectedSwimlane({})
    setOpenModal(true)
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (!defaultLangCheck) {
        raiseToast('error', 'Reordering Allowed only on Default Language')
        return
      }
      setShowChange(true)
      const data = [...swimlane]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setSwimlane([...data])
    },
    handleSelector: '',
  }
  return (
    <>
      <CCard style={{ minHeight: '37rem' }} className="position-relative">
        <CRow className="mx-5 mt-5">
          <div className="px-2 d-md-flex justify-content-md-end">
            <CButton
              className="text-white"
              color="info"
              onClick={handleAdd}
              disabled={!createAllowed}
              style={{ pointerEvents: 'auto' }}
              title={defaultLangCheck ? '' : 'Adding Swimalne Available on Default Language'}
            >
              <FontAwesomeIcon icon={faPlusCircle} className="mx-2" />
              Add Swimlane
            </CButton>
          </div>
        </CRow>

        <div className="mt-2 mx-5">
          <p className="h4">Added Swimlane List</p>
          <div style={{ maxHeight: '25rem' }} className="scrollbar-class tableFixHead">
            <ReactDragListView {...dragProps}>
              <CTable className="mt-" hover={defaultLangCheck}>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell style={{ width: '15%' }}>Serial No.</CTableHeaderCell>
                    <CTableHeaderCell style={{ width: '40%' }}>Name</CTableHeaderCell>
                    {/* <CTableHeaderCell>Content Limit</CTableHeaderCell> */}
                    <CTableHeaderCell style={{ width: '30%' }}>Swimlane Type</CTableHeaderCell>
                    <CTableHeaderCell style={{ textAlign: 'center', width: '10%' }}>
                      <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" />
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {!isEmpty(swimlane) ? (
                    swimlane.map((item, index) => (
                      <CTableRow
                        key={index}
                        style={{ cursor: `${defaultLangCheck ? 'move' : ''}` }}
                      >
                        <CTableDataCell style={{ width: '15%' }} align="middle">
                          {index + 1}
                        </CTableDataCell>
                        <CTableDataCell style={{ width: '40%' }} align="middle">
                          {item.name}
                        </CTableDataCell>
                        {/* <CTableDataCell align="middle">{item.limit}</CTableDataCell> */}
                        <CTableDataCell style={{ width: '30%' }} align="middle">
                          {item.type}
                        </CTableDataCell>
                        <CTableDataCell
                          align="middle"
                          style={{ textAlign: 'center', width: '10%' }}
                        >
                          <CIcon
                            icon={cilPencil}
                            style={{ cursor: 'pointer' }}
                            size="lg"
                            title="Edit Swimalne"
                            className="mx-2"
                            onClick={() => handleEdit(item, index)}
                          />
                          <CIcon
                            icon={cilTrash}
                            style={{ cursor: 'pointer', color: 'red' }}
                            size="lg"
                            title={
                              !defaultLangCheck
                                ? 'Deleting Swimalne Available on Default Language'
                                : 'Delete Swimalne'
                            }
                            className="mx-2"
                            onClick={defaultLangCheck ? () => deleteSwimlane(index) : null}
                            disabled={!defaultLangCheck}
                          />
                        </CTableDataCell>
                      </CTableRow>
                    ))
                  ) : (
                    <CTableRow>
                      <CTableDataCell colSpan="6">
                        <p>No Swimlanes Found</p>
                      </CTableDataCell>
                    </CTableRow>
                  )}
                </CTableBody>
              </CTable>
            </ReactDragListView>
            <div className="mx-5 d-flex justify-content-end">
              <p className="h5">
                {!isEmpty(swimlane) &&
                  defaultLangCheck &&
                  swimlane.length > 1 &&
                  updateAllowed &&
                  `* Drag the item to re-arrange`}
              </p>
            </div>
          </div>
        </div>

        {showChange && updateAllowed && (
          <div className="mx-5 my-2 position-absolute bottom-0 end-0">
            <CButton className="text-white mx-3 mt-5" color="info" onClick={onCancelReorder}>
              Cancel
            </CButton>
            <CButton className="text-white mt-5" color="info" onClick={saveReorder}>
              Save
            </CButton>
          </div>
        )}
      </CCard>
      {openModal && (
        <SwimlaneModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          subCategories={subCategories}
          categories={categories}
          countries={countries}
          customMetadataMaster={customMetadataMaster}
          customMetadata={customMetadata}
          subscriptions={subscriptions}
          selectedSwimlane={selectedSwimlane}
          swimlaneCallback={swimlaneCallback}
          onCancel={() => {
            setSelectedSwimlane({})
            setOpenModal(false)
          }}
        />
      )}
      {/* ..............Delete Modal.......... */}
      <CModal visible={deleteModal} alignment="center">
        <CModalHeader>
          <CModalTitle>Are you sure you want to delete this Swimlane?</CModalTitle>
        </CModalHeader>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={handleCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleConfirm}>
            Yes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default SwimlaneHomePage
